export default (props, { colors, rhythm, treatments }) => {
  return {
    nav: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      marginTop: rhythm(1),
      overflow: 'auto',
      ':before': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        borderBottom: `1px solid ${colors.lightGrey}`
      }
    },
    tab: {
      ...treatments.button,
      padding: rhythm([0.5, 0.75]),
      backgroundColor: 'white',
      border: `1px solid #eee`,
      borderBottomColor: colors.lightGrey,
      color: 'grey',
      '&:hover': {
        color: 'black'
      }
    },
    active: {
      color: 'black',
      position: 'relative',
      borderColor: colors.lightGrey,
      borderBottomColor: 'white',
      boxShadow: '0 0 5px rgba(0,0,0,0.1), 0 1px 0 1px white'
    }
  }
}
